import React from 'react'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'
import styles from './styles'

const ListCallToAction = ({ filtersSelected, totalCandidates }) => {
  const { addTrackingForCTA } = useAnalytics()

  return (
    <div className={styles.footerDetails}>
      {Object.keys(filtersSelected).length === 0 ? (
        <strong>{totalCandidates} developers are actively looking, get started to talk to them.</strong>
      ) : (
        <strong>{totalCandidates} candidates match your filters, get started to talk to them.</strong>
      )}
      <p>Want to try OfferZen? Sign up to browse active developers. No upfront payment required.</p>
      <div className={styles.footerCtaContainer}>
        <a
          {...addTrackingForCTA({
            action: 'clicked get access',
            sourceDetail: 'candidate list cta',
            url: '/hire/get-started?marketplace_preview_lead=true',
          })}
          className={cx(styles.footerCtaButton, styles.signupButton)}>
          Get access to developers
        </a>
        <a
          {...addTrackingForCTA({
            action: 'Clicked book a demo',
            sourceDetail: 'candidate list cta',
            url: '/hire/book-call?marketplace_preview_lead=true',
          })}
          className={cx(styles.footerCtaButton, styles.bookDemoButton)}>
          Book a demo
        </a>
      </div>
    </div>
  )
}

ListCallToAction.propTypes = {
  filtersSelected: PropTypes.object,
  totalCandidates: PropTypes.number,
}

export default ListCallToAction
